var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isVisible())?_c('div',{staticClass:"reaction-component-container"},[_c('div',{staticClass:"reaction-icon"},[_c('span',{class:_vm.iconClasses()},[_c('span',{staticClass:"icon"})])])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }